export const MN_ALLOWED_FILE_TYPES_FOR_PLANS = '.xml,.pdf,.doc, .docx, .xls, .xlsx';
export const ALLOWED_FILE_TYPES_FOR_PLANS = 'application/xml';
export const ALLOWED_FILE_TYPE_FOR_DRUGS = '.xml,.json';

export const XML_TYPE_FILE = 'text/xml';
export const PDF_TYPE_FILE = 'application/pdf';

export enum FILE_TYPE {
    XML = 'XML',
    JSON = 'JSON',
}